export const isRTL = (): boolean => {
    return document.documentElement.dir === 'rtl';
};